import { Reveal, SectionHead } from "./Reveal";

const STEPS = [
  ["Conversa inicial", "Você conta sobre sua empresa e o que precisa. Sem compromisso."],
  ["Briefing & estratégia", "Organizamos objetivos, páginas, conteúdo e referências."],
  ["Direção visual", "Criamos o layout autoral e ajustamos com você."],
  ["Desenvolvimento", "Transformamos o design em um site rápido e responsivo."],
  ["Publicação", "Revisão final, testes e o site no ar."],
];

export const Process = () => (
  <section id="processo" data-testid="process-section" className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-24 lg:py-40">
    <SectionHead index="04" label="Processo" title={<>Da primeira conversa à <span className="font-serif italic font-normal text-gold">publicação</span>.</>} />
    <ol className="grid lg:grid-cols-5 border-l lg:border-l-0 lg:border-t border-white/10">
      {STEPS.map(([t, d], i) => (
        <Reveal as="li" key={t} delay={i * 0.08} className="relative pl-8 lg:pl-0 lg:pr-8 pb-12 lg:pb-0 lg:pt-10">
          <span className="absolute -left-[5px] top-1 lg:left-0 lg:-top-[5px] h-[9px] w-[9px] rounded-full bg-[#050505] border border-[#D4AF5A]" />
          <span className="font-serif italic text-5xl text-gold">0{i + 1}</span>
          <h3 className="mt-4 font-display text-xl font-semibold">{t}</h3>
          <p className="mt-2 text-[#A7A7AD] text-[15px] leading-relaxed">{d}</p>
        </Reveal>
      ))}
    </ol>
  </section>
);
